import axios from 'axios';
import { agent, API_MAP } from 'helpers';
import { API_MYEDUZZ } from 'settings';

import type IProfile from 'interfaces/IProfile';

class ProfileService {
  static listBanks(international?: boolean) {
    if (international) {
      return agent.get(`${API_MAP.listBanks}?international=true`);
    } else {
      return agent.get(API_MAP.listBanks);
    }
  }

  static resendConfirmation(uuid: string) {
    return agent.post(`${API_MYEDUZZ}/fundtransfers/${uuid}/resend-confirmation`, {});
  }

  static listAccounts(active?: string) {
    let params = '';

    if (active) {
      params += '?active=true';
    }

    return agent.get(API_MAP.listAccounts + params);
  }

  static createAccount(data: any) {
    let newAccount: any = {};

    // faz o destructuring dos dados, retira o array e deixa apenas os outros dados
    const { ...rest } = data;

    newAccount = rest;

    // transforma o array de imagens para o padrão da api
    // e adiciona no objeto que será enviado para a api
    if (data.imgsIds['imgDocCNH']) {
      newAccount.driver_license_image = data.imgsIds['imgDocCNH'];
    }
    if (data.imgsIds['imgDocCPF']) {
      newAccount.tax_document_image = data.imgsIds['imgDocCPF'];
    }
    if (data.imgsIds['imgDocRG']) {
      newAccount.personal_document_image = data.imgsIds['imgDocRG'];
    }
    if (data.imgsIds['videoDoc']) {
      newAccount.personal_document_video = data.imgsIds['videoDoc'];
    }
    if (data.imgsIds['imgAddress']) {
      newAccount.address_image = data.imgsIds['imgAddress'];
    }

    return agent.post(`${API_MAP.createAccount}`, newAccount);
  }
  static getMyProfile() {
    return agent.get(API_MAP.getMyProfile);
  }

  static isNewbie() {
    return agent.get(API_MAP.isNewbie);
  }

  static saveMyProfile(profile: IProfile) {
    return agent.put(API_MAP.saveMyProfile, profile);
  }
  static getAddressByZipCode(zipCode: string) {
    return axios({
      method: 'GET',
      baseURL: API_MAP.getAddressByZipCode.replace('{zip_code}', zipCode),
      headers: {
        'Content-type': 'application/json',
      },
    });
  }

  static saveTourAction(tour: string) {
    return agent.post(API_MAP.saveTourAction, { tour });
  }

  static checkPassword(user: any) {
    let userData = {
      email: user.email,
      password: user.password,
    };
    return agent.post(API_MAP.checkPassword, userData);
  }
}

export default ProfileService;
